import 'owl.carousel';
import 'owl.carousel2.thumbs';
import 'waypoints/lib/jquery.waypoints.min';
import 'waypoints/lib/shortcuts/inview.min';

if($(window).width() < 968) {
    var inview = new Waypoint.Inview({
        element: $('.header')[0],
        enter: function(direction) {
          console.log('Enter triggered with direction ' + direction)
          if(direction == "up") {
            $('.fixed-btn').css({'position':'relative'});
          }
        },
        entered: function(direction) {
          console.log('Entered triggered with direction ' + direction);
        },
        exit: function(direction) {
          console.log('Exit triggered with direction ' + direction);
          
        },
        exited: function(direction) {
          console.log('Exited triggered with direction ' + direction)
          if(direction == "down") {
            $('.fixed-btn').css({'position':'fixed'});
          }
        }
    });
}
/*
    sub-menu
*/
$('.submenu').on('click', function() {
    $(this).next().fadeIn(400);
});
$('.sub-big-menu .back').on('click', function(e) {
    e.preventDefault();
    $('.sub-big-menu').fadeOut(400);
});
/*
    click menu
*/
$('.box-close').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('close-transform');
    $(this).parents('header').toggleClass('show-nav');
    if($(this).hasClass('close-transform')) {
        $('.nav-main').fadeIn(300);
        $('html, body').addClass('scroll-none');
    } else {
        $('.nav-main').fadeOut(300);
        $('html, body').removeClass('scroll-none');
    }
});

$('.filter-mobile').on('click', function(){
    $('html, body').addClass('scroll-none');
    $('html, body').scrollTop(0);
    $('.filter-checkbox').css('display','flex').fadeIn(400);
});

$('.filter-checkbox .title-mobile img').on('click', function(){
    $('html, body').removeClass('scroll-none');
    $('.filter-checkbox').fadeOut(400);
});

$(window).on('load', function() {
    $(".page-general__slider-fullvideo .owl-carousel").owlCarousel({
        items: 1,
        loop: false,
        nav: true,
        dots: true,
        margin: 0,
        animateOut: 'fadeOut',
        autoplay: false,
        autoplayTimeout: 5000,
        autoplayHoverPause: false
    });
    $(".page-general__slider-fullvideo .owl-carousel").on('change.owl.carousel', function(e) {
        setTimeout(function() {
            $('.owl-item').each(function(i) {  
                if($(this).hasClass('active')) {
                    var playVideo = $(this).find('video').get(0);
                    if( typeof playVideo == 'undefined' ) {
                        return true;
                    }
                    $(this).find('video').get(0).play();
                    $('.owl-item').not(this).find('video').trigger('pause');
                }
            });
        },400);
    });
    $('.owl-item').each(function(i) {  
        if($(this).hasClass('active')) {
            var playVideo = $(this).find('video').get(0);
            if( typeof playVideo == 'undefined' ) {
                return true;
            }
            $(this).find('video').get(0).play();
            $('.owl-item').not(this).find('video').trigger('pause');
        }
    });
});

/* slider effect */
$('.page-general__slider-effect .owl-carousel').owlCarousel({
    loop: true,
    nav: true,
    dots: false,
    stagePadding: 100,
    margin: 1,
    autoWidth:false,
    responsive : {
        0 : {
            items: 1,
            stagePadding: 30,
        },
        900 : {
            items: 2,
            stagePadding: 100
        },
        1280 : {
            items: 3
        },
        1400: {
            items: 3
        },
        1700 : {
            items: 4
        }
    }
});

/* slider social */
$('.slider-left .owl-carousel').owlCarousel({
    items: 4,
    loop: true,
    nav: false,
    dots: false,
    margin: 15,
    responsive : {
        0 : {
            margin: 35,
            items: 2,
            center: true,
            stagePadding: 30,
        },
        680 : {
            margin: 35,
            items: 2,
            center: true,
            stagePadding: 100,
        },
        900 : {
            margin: 15,
            center: false,
            items: 4,
            stagePadding: 0,
        }
    }
});

/* slider left product */
$('.slider-left-product .owl-carousel').owlCarousel({
    items: 5,
    loop: true,
    nav: true,
    dots: false,
    margin: 15,
    stagePadding: 70,
    responsive : {
        0 : {
            items: 1,
            stagePadding: 50
        },
        680 : {
            items: 2,
            stagePadding: 90
        },
        900 : {
            items: 3,
            stagePadding: 70
        },
        1280 : {
            items: 4,
            stagePadding: 80
        },
        1700 : {
            items: 5,
            stagePadding: 70
        }
    }
});
/* slider effect */
$('.products .owl-carousel').owlCarousel({
    loop: true,
    nav: true,
    dots: false,
    stagePadding: 70,
    margin: 0,
    responsive : {
        0 : {
            items: 1,
            margin: 20,
            stagePadding: 60,
        },
        680 : {
            items: 2,
            margin: 0,
            stagePadding: 70
        },
        700 : {
            items: 2,
            margin: 0,
            stagePadding: 50
        },
        1000 : {
            items: 3,
            margin: 0,
            stagePadding: 70
        },
        1200 : {
            items: 3,
            margin: 0,
            stagePadding: 100
        },
        1400 : {
            items: 3,
            margin: 0,
            stagePadding: 130
        },
        1600 : {
            items: 4,
            margin: 0,
            stagePadding: 100
        },
        1700 : {
            items: 4,
            stagePadding: 90
        }
    }
});
/* thumbs slider */
$('.box-slider .owl-carousel').each(function(){
    $(this).owlCarousel({
        loop: true,
        dots: false,
        lazyLoad: true,
        items: 1,
        thumbImage: true,
        thumbContainerClass: 'owl-thumbs',
        thumbItemClass: 'owl-thumb-item',
        animateOut: 'fadeOut',
        responsive : {
            0 : {
                items: 1,
                thumbs: false,
                thumbImage: false,
                dots: true,
            },
            680 : {
                items: 1,
                thumbs: true,
                thumbImage: false,
                dots: false,
            }
        }
    });
});

/* rare-slider */
$('.rare-slider .owl-carousel').owlCarousel({
    items: 3,
    loop: true,
    nav: true,
    dots: false,
    margin: 15,
    center: true,
    //navText: ["<img src='../assets/images/left.svg'>","<img src='../assets/images/right.svg'>"],
    responsive : {
        0 : {
            items: 1,
            stagePadding: 50,
        },
        680 : {
            items: 1,
            stagePadding: 200,
        },
        1280 : {
            items: 1,
            stagePadding: 300,
        },
        1700 : {
            items: 1,
            stagePadding: 350,
        }
    }
});
/* change img src */
$('.change a').on('click', function(e){
    e.preventDefault();
    $('.change a').not(this).removeClass('active');
    $(this).addClass('active');
    $(this).not(this).removeClass('active');
    var index_parent = $(this).parent().attr('data-change');
    var index = $('.change a').index(this);
    
    $('.col-left .gallery').each(function(i) {
        if(index_parent == i) {
            $(this).fadeIn(0);
            $('.col-left .gallery').not(this).fadeOut(0);
        }
    });
    $('.col-left .box-slider-parent').each(function(i) {
        if(i == index) {
            $(this).addClass('active').removeClass('none');
            $('.col-left .box-slider-parent').not(this).addClass('none').removeClass('active');
        }
    });
});
/* tags close */
/*$('.tags-items .close-tag').on('click', function() {
    $(this).parents('.tag').remove();
});*/
/* filter product detail */
$('.filter-span .box-select .print').on('click', function() {
    var total = 0;
    $(this).next().find('li').each(function(i){
        console.log(i);
        if(i <= 2) {
            total += $(this).innerHeight() + 1;
        }
    });
    $(this).toggleClass('open-nav');
    if($(this).hasClass('open-nav')){
        $(this).next().css('height',total+'px');
    } else {
        $(this).next().css('height','0px');
    }
});
$('.filter-span .box-select .print').next().find('li').on('click',function(){
    $(this).parents('.box-select').find('.print span').text($(this).text());
    $(this).parents('.box-select').find('.print').removeClass('open-nav');
    $(this).parent().css('height','0px');
});
/* filter larges */
$('.filter-checkbox .box-select .print').on('click', function() {
    var total = 0;
    $(this).next().find('li').each(function(i){
        console.log(i);
        if(i <= 5) {
            total += $(this).innerHeight() + 1;
        }
    });
    $(this).toggleClass('open-nav');
    if($(this).hasClass('open-nav')){
        $(this).next().css('height',total+'px');
    } else {
        $(this).next().css('height','0px');
    }
    $('.filter-checkbox .box-select .print').not(this).next().css('height','0px');
    $('.filter-checkbox .box-select .print').not(this).removeClass('open-nav')
});
/* filter search page */
$('.filter-search .box-select .print').on('click', function() {
    var total = 0;
    $(this).next().find('li').each(function(i){
        console.log(i);
        if(i <= 5) {
            total += $(this).innerHeight() + 1;
        }
    });
    $(this).toggleClass('open-nav');
    if($(this).hasClass('open-nav')){
        $(this).next().css('height',total+'px');
    } else {
        $(this).next().css('height','0px');
    }
    $('.filter-search .box-select .print').not(this).next().css('height','0px');
    $('.filter-search .box-select .print').not(this).removeClass('open-nav')
});
$('.filter-search .box-select .print').next().find('li').on('click',function(){
    $(this).parents('.box-select').find('.print span').text($(this).text());
    $(this).parents('.box-select').find('.print').removeClass('open-nav');
    $(this).parent().css('height','0px');
});

$('.modal-left-product').on('click', function(e) {
    e.preventDefault();
    $('.modal-product').addClass('move');
});
$('.close-yellow').on('click', function(e) {
    e.preventDefault();
    $('.modal-product').removeClass('move');
});
$('.modal-cookie a').first().on('click', function(e) {
    e.preventDefault();
    $('.modal-cookie').fadeOut(400);
});
$('.playbtn').on('click', function(){
    $('#sample_video').get(0).play(); 
    $('.video-box img').fadeOut(400);
});
/*
  acordeon 
*/
$('.col-acordeon a').on('click',function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    if($(this).hasClass('active')) {
      $(this).next().slideDown(300);
      $(this).find('.fas').removeClass('fa-plus').addClass('fa-minus');
    } else {
      $(this).next().slideUp(300);
      $(this).find('.fas').addClass('fa-plus').removeClass('fa-minus');
    }
    $('.col-acordeon a').not(this).removeClass('active')
    $('.col-acordeon a').not(this).find('.fas').removeClass('fa-minus').addClass('fa-plus');
    $('.col-acordeon a').not(this).next().slideUp(300);
});

/*
    form search
*/
/*$(".search-form-modal").submit(function(e){
    $('.modal-search .box-middle').addClass('search-error');
    return false;
});*/

$('.search-open a').on('click', function(e) {
    e.preventDefault();
    $('.modal-search').css('display', 'flex').fadeIn(300);
    setTimeout(function(){
        $('.modal-search input').focus(); 
    },320);
});

$('.modal-search .close-yellow').on('click', function(e) {
    e.preventDefault();
    $('.modal-search').fadeOut(300);
});

/* show file */
$('#uploadBtn').on('change', function(){
    $('#attachments').html('');
    var attachments = document.getElementById('uploadBtn');
    var item = '';
    for(var i=0; i<attachments.files.length; i++) {
        item += '<li class="col-md-4"><div class="img"><span>' + attachments.files.item(i).name +
            '</span><a href="#" id="'+ i +'" class="dlt-attch"><i class="far fa-trash-alt"></i></div></a>' +
            '</li>';
        console.log(attachments.files.item(i).name);
    }
    $('#attachments').append(item);
    $('.dlt-attch').on('click', function(e){
        e.preventDefault();
        var id = $(this).attr('id');
        console.log(attachments.files);
        $(this).parents('li').remove();
    });
});

$('#uploadBtn2').on('change', function(){
    $('#attachments2').html('');
    var attachments = document.getElementById('uploadBtn2');
    var item = '';
    for(var i=0; i<attachments.files.length; i++) {
        item += '<li class="col-md-4"><div class="img"><span>' + attachments.files.item(i).name +
            '</span><a href="#" id="'+ i +'" class="dlt-attch2"><i class="far fa-trash-alt"></i></div></a>' +
            '</li>';
        console.log(attachments.files.item(i).name);
    }
    $('#attachments2').append(item);
    $('.dlt-attch2').on('click', function(e){
        e.preventDefault();
        var id = $(this).attr('id');
        console.log(attachments.files);
        $(this).parents('li').remove();
    });
});

/* open radio section */
$(".radio-custom").on('change', function(){
    if( $(this).is(":checked") ){
        var val = $(this).val();
        console.log(val);
        $('.consumer-inquiry').each(function(){
            var each_val = $(this).attr('data-val');
            if(val == each_val) {
                $(this).css('display', 'flex');
                $('.consumer-inquiry').not(this).css('display', 'none');
            }
        });
    }
});


//Filter events
let isAjaxRunning = false;
$('.tags-items').on('click', '.close-tag', function() {
    if (isAjaxRunning) return;

    let checkboxId = $(this).parent().find('a').data('checkbox-id');
    $(this).parents('.tag').remove();

    $('#' + checkboxId).prop('checked', false);

    $('#filter-form #current-page-number').val(1);
    loadFilterResults();
});

//Get results with delay. 
function loadFilterResults() {
    if ($(".buttons-mobile-filter").is(":visible")) return;

    $('#result-container .row').html('');
    $('html, body').scrollTop($('#filter-form').offset().top - 30);
    $('#filter-form').trigger('submit'); //This will send the form data.
}

$('.filter-checkbox input[type=checkbox]').on('change', function() {
    let _this = $(this);
    if(_this.data('ignore-filter')) return;

    if (isAjaxRunning) {
        _this.prop('checked', !_this.is(":checked"));

        return;
    }

    if (_this.val() === 'A-Z') $('#tag_Z-A').parent('.tag').find('.close-tag').trigger('click');
    else if (_this.val() === 'Z-A') $('#tag_A-Z').parent('.tag').find('.close-tag').trigger('click'); 
    
    if(_this.is(":checked")) {
        $('.tags-items').append(
            `<div class="tag">
                <a href="#" id="tag_${ _this.val().replace(/ /g, '-') }" data-checkbox-id="${ _this.attr('id') }">${ _this.data('name') }</a> 
                <span class="close-tag"><img src="${themeUrl}/src/assets/images/close-green.svg" alt="close"></span>
            </div>`
        );
    } else $('#tag_' + _this.val().replace(/ /g, '-')).parents('.tag').remove();

    $('#filter-form #current-page-number').val(1);
    loadFilterResults();
});


$('#filter-form').on('submit', function(e) {
    e.preventDefault();

    if (isAjaxRunning) return;
    isAjaxRunning = true;

    let form = $(this);
    let data = form.serializeArray();

    $('.filter-checkbox input[type=checkbox]').attr('disabled', true);
    $('#result-container row').html(''); 

    $.ajax({
        method: form.attr('method'),
        url: form.attr('action'),
        data: data
    })
    .done(function( html ) {
        $('#result-container').html(html);

        if ($('#post-count').val() != -1) $('#result-count').text($('#post-count').val());
        else $('#result-count').text($('.product-item').length);
    }).fail(function() {
        $('#result-container').html('');
        $('#result-count').text(0);
    }).always(function() {
        isAjaxRunning = false;

        $('.filter-checkbox input[type=checkbox]').attr("disabled", false);
    });
});


//Ajax pagination result-container
$('#result-container').on('click', '.ajax.pagination .page-number', function(e) {
    e.preventDefault();
    if (isAjaxRunning) return;

    let _this = $(this);
    let clickedPage = _this.text();

    let pagination = _this.parent().parent();
    let currents = pagination.find('.current');
    currents.removeClass('current');
    
    //_this.parent().addClass('current');

    $('#filter-form #current-page-number').val(clickedPage);
    loadFilterResults();
});

//Next button
$('#result-container').on('click', '.ajax .page-item.last', function(e) {
    e.preventDefault();
    if (isAjaxRunning) return;

    let currentPage = $('#filter-form #current-page-number');
    let nextPageNumber = parseInt(currentPage.val()) + 1;

    currentPage.val(nextPageNumber);
    loadFilterResults();
});

//Previous button
$('#result-container').on('click', '.ajax .page-item.first', function(e) {
    e.preventDefault();
    if (isAjaxRunning) return;

    let currentPage = $('#filter-form #current-page-number');
    let previousPageNumber = parseInt(currentPage.val()) + -1;

    currentPage.val(previousPageNumber);
    loadFilterResults();
});

$('.buttons-mobile-filter .yellow-btn').on('click', function(e) {
    e.preventDefault();

    $('#filter-form').trigger('submit');
    $('.filter-checkbox .title-mobile img').trigger('click');
});

$('.buttons-mobile-filter .white-btn').on('click', function(e) {
    e.preventDefault();

    $('.filter-checkbox input[type=checkbox]:checked').each(function() {
        $(this).trigger('click');
    });
});

$('.redirect-checkbox').on('change', function() {
    let _this = $(this);
    let ul = _this.closest('ul');
    let allCheckboxes = ul.find('.redirect-checkbox');

    if (_this.is(':checked')) { 
        allCheckboxes.not(_this).prop('checked', false);
        location.href = _this.val();
    } else {
        location.href = allCheckboxes.first().val();
    }
});

$('#search-faq').on('submit', function(e) {
    e.preventDefault();

    let form = $(this);
    let term = form.find('#term').val();
    let terms = term.split(' ');

    terms= terms.map(function(el) { 
        return '(?=.*' + el + ')'; 
    });

    terms = terms.join('').toLowerCase();

    let isTermFound = false;

    $('#faq-list li').each(function(index, element) {
        let jqElement = $(element);

        let question = jqElement.find('a span').text().toLowerCase();
        let answer = jqElement.find('.box-info p').text().toLowerCase();

        if (question.search(new RegExp(terms, "img")) == -1 && answer.search(new RegExp(terms, "img")) == -1) return true;
        if (!jqElement.find('a').hasClass('active')) jqElement.find('a').trigger('click');

        isTermFound = true;

        $('html, body').animate({
            scrollTop: jqElement.offset().top - 30
        }, 2000);

        return false;
    });

    console.log("isTermFound", isTermFound);

    if (isTermFound) $('#error-message').hide();
    else $('#error-message').show();
});

$('#order-select li').on('click', function(e) {
    let jqElement = $(this);
    let selectedValue = jqElement.find('a').data('value');

    $('#selected-order').val(selectedValue);
    $('.search-form').trigger('submit');
});

$('#category-select li').on('click', function(e) {
    let jqElement = $(this);
    let selectedValue = jqElement.find('a').data('value');

    $('#selected-category').val(selectedValue);
    $('.search-form').trigger('submit');
});

$('#agree-to-terms').on('click', function(e) {
    e.preventDefault();

    localStorage.setItem('tycs', 'yes');
    $('.modal-cookie .close-m').trigger('click');
});


if (localStorage.getItem('tycs') == null) {
    $('.modal-cookie').show();
}

$('.copy-href-to-clipboard').on('click', function (e) {
    e.preventDefault();

    var copyText = $(this).attr('href');
    document.addEventListener('copy', function(e) {
       e.clipboardData.setData('text/plain', copyText);
       e.preventDefault();
    }, true);
    var __this = $(this);
    __this.append( "<small>Copied!</small>" );
    setTimeout(function() {
        __this.find("small").remove();
    },1500);
    document.execCommand('copy');  
  });

  $('.buynow').on('click', function(e) {
    var containerId = $(this).attr('data-destini-container');
    var associationId = $(this).attr('data-destini-association');
    
    var APO = $(this).attr('data-destini-apo');
    

    destini.init(containerId);
    destini.loadWidget(associationId, APO);
});

$('.print-btn').on('click', function(e) {
    e.preventDefault();

    window.print();
});


$('.fbm-desktop-share').on('click', function() {
    FB.init({
        appId      : '2617493428544674',
        status     : true,
        xfbml      : true,
        cookie: true,
        version    : 'v2.7'
    });


    FB.ui({
        method: 'send',
        link: window.location.href
    }, function() {
      
    });
})